<template>
    <div class="row mainpage">
        <div class="seo">
            <seo-title content="Volkswagen Erhvervsklub - Din Volkswagen familie"></seo-title>
            <seo-description content="Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-description>
            <seo-author content="Deveo ApS"></seo-author>
            <seo-keywords content="VW, VW Erhvervscenter, VW Erhvervsbiler, VW Erhvervsklub, Volkswagen"></seo-keywords>
            <seo-og-title content="Volkswagen Erhvervsklub - Din Volkswagen familie"></seo-og-title>
            <seo-og-description content="Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-og-description>
            <seo-google-name content="Volkswagen Erhvervsklub - Din Volkswagen familie"></seo-google-name>
            <seo-google-description content="Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-google-description>
            <seo-google-image content=""></seo-google-image>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
            <h1 class="custom-header">
                <span>Volkswagen</span>
                Erhvervsklub
            </h1>
            <p class="custom-body">
                Vælg din foretrukne forhandler
            </p>
            <div class="loader" style="margin:10px 0 20px 0;opacity:0.75;text-align:center;" v-if="!loaded">
                <i class="fa fa-circle-o-notch fa-spin" style="font-size:48px;color:#0099da;"></i><br>
                Finder din nærmeste forhandler
            </div>
            <ul class="list-group" :class="{'location': located}">
                <li class="list-group-item" v-for="store in activeStores">
                    <div class="row">
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <img src="static/images/vw-logo.png"/>
                            <sup v-if="store.distance !== ''">{{ store.distance }}km</sup>
                        </div>
                        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                            {{ store.name }}
                            <span>
                                {{ store.street }}<br>
                                {{ store.city }}
                            </span>
                            <div class="chooser">
                                <a :href="store.link" v-if="store.active">
                                    <span>Vælg</span>
                                </a>
                                <i v-else>Kommer<br>snart</i>
                            </div>
                            <div class="closest">
                                <i class="fa fa-map-marker"></i> Baseret på din lokation
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6">

        </div>
    </div>
</template>
<script>
    import _ from 'underscore'
    export default {
        name: 'Index',
        created () {
            window.fbq('trackCustom', 'Landing')
        },
        data () {
            return {
                loaded: false,
                located: false,
                stores: [
                    {
                        name: 'Amager',
                        street: 'Englandsvej 437',
                        city: '2770 Kastrup',
                        link: '/amager',
                        lat: 55.613599,
                        lng: 12.612724,
                        selected: false,
                        distance: '',
                        active: true,
                        show: true
                    },
                    {
                        name: 'Gladsaxe',
                        street: 'Dynamovej 5',
                        city: '2860 Søborg',
                        link: '/gladsaxe',
                        lat: 55.733158,
                        lng: 12.462465,
                        selected: false,
                        distance: '',
                        active: true,
                        show: true
                    },
                    {
                        name: 'Hillerød',
                        street: 'Egespurs Alle 1',
                        city: '3400 Hillerød',
                        link: '/hilleroed',
                        lat: 55.928985,
                        lng: 12.263102,
                        selected: false,
                        distance: '',
                        active: false,
                        show: false
                    },
                    {
                        name: 'København',
                        street: 'Banevingen 9',
                        city: '2200 København N',
                        link: '/kobenhavn',
                        lat: 55.706212,
                        lng: 12.543432,
                        selected: false,
                        distance: '',
                        active: true,
                        show: true
                    },
                    {
                        name: 'Køge',
                        street: 'Tangmosevej 110',
                        city: '4600 Køge',
                        link: '/koege',
                        lat: 55.475290,
                        lng: 12.185744,
                        selected: false,
                        distance: '',
                        active: false,
                        show: false
                    },
                    {
                        name: 'Odense',
                        street: 'Middelfartvej 50',
                        city: '5200 Odense V',
                        link: '/odense',
                        lat: 55.393794,
                        lng: 10.356851,
                        selected: false,
                        distance: '',
                        active: false,
                        show: true
                    }
                ]
            }
        },
        mounted () {
            this.getLocation()
        },
        methods: {
            getLocation () {
                if (!navigator.geolocation) {
                    this.loaded = true
                    return
                }
                navigator.geolocation.getCurrentPosition((position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }

                    this.stores.forEach((store) => {
                        store.distance = parseInt(this.calculateDistance(store.lat, store.lng, pos.lat, pos.lng))
                    })

                    this.loaded = true
                    this.located = true
                }, () => {
                    this.loaded = true
                })
            },
            calculateDistance (lat1, lon1, lat2, lon2) {
                const p = 0.017453292519943295
                const c = Math.cos
                const a = 0.5 - c((lat2 - lat1) * p) / 2 +
                    c(lat1 * p) * c(lat2 * p) *
                    (1 - c((lon2 - lon1) * p)) / 2
                const subtotal = 12742 * Math.asin(Math.sqrt(a))

                return subtotal.toFixed(0)
            }
        },
        computed: {
            activeStores () {
                const filtered = this.stores.filter((store) => {
                    return store.show === true
                })

                return _.sortBy(filtered, 'distance')
            }
        }
    }
</script>
<style lang="scss">
    @import url('../../styles/main/index.scss');
</style>



// WEBPACK FOOTER //
// index.vue?12f99bd6